import { render, staticRenderFns } from "./Trips.html?vue&type=template&id=2fcae51d&scoped=true&external"
import script from "./Trips.js?vue&type=script&lang=js&external"
export * from "./Trips.js?vue&type=script&lang=js&external"
import style0 from "./Trips.vue?vue&type=style&index=0&id=2fcae51d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcae51d",
  null
  
)

export default component.exports